import { Colors } from '~/themes/colors';

export const BriefcaseSolidIcon = ({ color = Colors.secondary_500 }) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.1999 7.1999V5.9999C7.1999 4.01168 8.81168 2.3999 10.7999 2.3999H13.1999C15.1881 2.3999 16.7999 4.01168 16.7999 5.9999V7.1999H19.1999C20.5254 7.1999 21.5999 8.27442 21.5999 9.5999V13.8848C18.6115 14.9936 15.3778 15.5998 11.9999 15.5998C8.62208 15.5998 5.38834 14.9936 2.3999 13.8848V9.5999C2.3999 8.27442 3.47442 7.1999 4.7999 7.1999H7.1999ZM9.5999 5.9999C9.5999 5.33716 10.1372 4.7999 10.7999 4.7999H13.1999C13.8626 4.7999 14.3999 5.33716 14.3999 5.9999V7.1999H9.5999V5.9999ZM10.7999 11.9999C10.7999 11.3372 11.3372 10.7999 11.9999 10.7999H12.0119C12.6746 10.7999 13.2119 11.3372 13.2119 11.9999C13.2119 12.6626 12.6746 13.1999 12.0119 13.1999H11.9999C11.3372 13.1999 10.7999 12.6626 10.7999 11.9999Z"
      fill={color}
    />
    <path
      d="M2.3999 16.4306V19.1999C2.3999 20.5254 3.47442 21.5999 4.7999 21.5999H19.1999C20.5254 21.5999 21.5999 20.5254 21.5999 19.1999V16.4306C18.5846 17.4484 15.3556 17.9998 11.9999 17.9998C8.64425 17.9998 5.41526 17.4484 2.3999 16.4306Z"
      fill={color}
    />
  </svg>
);
